import { render } from "./barrage-layer.vue?vue&type=template&id=0ae78e4a"
import script from "./barrage-layer.vue?vue&type=script&lang=js"
export * from "./barrage-layer.vue?vue&type=script&lang=js"

import "./barrage-layer.vue?vue&type=style&index=0&id=0ae78e4a&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__